module.exports = __webpack_public_path__ + "img/3.eed13b3b.jpg";